import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import starIcon from '@/assets/app/images/icon/icon-star.png';
import TitleHeader from '../common/TitleHeader';
import useAppStore from '@/shared/store/UseAppStore';
import { getUploadsUrl, vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';
import { SegmentedProgressBar } from '../common/SegmentedProgressBar';
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';

interface Props {
  closeFunc: () => void;
  category?: BookEraCategory;
}

const BookPerson: React.FC<Props> = ({ closeFunc, category }) => {
  const [list, setList] = useState<BookPerson[]>([]);
  const { openSheet } = useBottomSheetStore();

  const loadData = async () => {
    await vAppAjax(
      'get',
      `my/book/person`,
      { eraCategoryId: category?.eraCategoryId },
      (response: AxiosResponse<CommonResult>) => {
        const resultData = response.data;
        if (resultData.code === 200) {
          setList(response.data.result);
        } else {
          logger.warn(resultData.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  const progress = 60; // 60%

  const handlePersonClick = (personInfo: BookPerson) => {
    openSheet('person-info', { showHeader: true, title: personInfo.personName, personInfo });
    // if (character.unlocked) {
    //   navigate(`/character/${character.id}`);
    // }
  };

  return (
    <div
      className="page-container page-container--white z-[10] w-full h-full bg-[#ffffff]"
      style={{ padding: 20, position: 'fixed', background: 'white', top: 0, left: 0 }}
    >
      <TitleHeader title={category?.categoryName || ''} onBack={() => closeFunc()} />
      <div
        style={{
          padding: '15px 20px',
        }}
      >
        <SegmentedProgressBar
          color={category?.themeColor}
          current={category?.completedPerson || 0}
          total={category?.totalPerson || 0}
        />
      </div>

      <div
        className="flex"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          columnGap: 16,
          justifyItems: 'center',
          rowGap: 30,
          padding: '15px 20px',
        }}
      >
        {list.map((item, idx) => {
          return (
            <div
              style={{
                position: 'relative',
              }}
              onClick={() => handlePersonClick(item)}
            >
              <div
                style={{
                  position: 'relative',
                  border: `6px solid ${category?.themeColor}`,
                  overflow: 'hidden',
                  borderRadius: 14,
                }}
              >
                <h2
                  className="text-white mb-6 text-outline-black absolute left-[5px] w-full top-[3px]"
                  style={{ fontSize: 14, fontFamily: 'SUIT' }}
                >
                  {item.personName}
                </h2>
                <img src={`${getUploadsUrl()}/person/${item.imageFilename}`} />{' '}
                <div
                  className="bg-[#072B5D] text-center"
                  style={{
                    position: 'absolute',
                    width: '100%',
                    bottom: 0,
                    fontSize: 12,
                    fontWeight: 800,
                    height: 15,
                    overflow: 'hidden',
                  }}
                >
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-white text-[10px] font-extrabold leading-none shadow-sm">
                      {item.eraName}
                    </span>
                  </div>
                </div>
              </div>

              {item.completedChapters && (
                <div className="absolute flex w-full justify-center h-auto" style={{ bottom: -14 }}>
                  {[...Array(item.completedChapters)].map((_, index) => (
                    <img src={starIcon} />
                  ))}
                </div>
              )}
              {!item.completedChapters && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: 14,
                    zIndex: 1,
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookPerson;
